__turbopack_context__.v({
  "container": "xOZF7a_container",
  "employee": "xOZF7a_employee",
  "headerTag": "xOZF7a_headerTag",
  "list": "xOZF7a_list",
  "navigation": "xOZF7a_navigation",
  "photo": "xOZF7a_photo",
  "swiperWrapper": "xOZF7a_swiperWrapper",
});
